import Vue from "vue";
import router from "./router";
import store from "@/store";
import App from "./App";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";
import Vuelidate from "vuelidate";

import VueToast from "vue-toast-notification";
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import "vue-toast-notification/dist/theme-sugar.css";
import VueTheMask from "vue-the-mask";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

// Bootstrap
import "bootstrap";

import Chartist from "chartist";
import helpers from "@/util";

import dayjs from "dayjs";

// VueYoutube
import VueYoutube from "vue-youtube";
Vue.use(VueYoutube);

const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

Vue.prototype.$Chartist = Chartist;
Vue.prototype.$moment = dayjs;
Vue.prototype.$helpers = helpers;

Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);
Vue.use(VuePlyr);
Vue.use(Vuelidate);
Vue.use(VueTheMask);

Vue.use(VueToast, {
  position: "top",
  duration: 6000
});

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import { faCross, faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
library.add(
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube,
  faFileArrowDown,
  faCross
);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-PGTFLJK1KP" }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  data: {
    Chartist: Chartist
  },
  render: h => h(App),
  router,
  store: store
});

// Filters
Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.directive("uppercase", {
  update: function(el) {
    el.value = el.value.toUpperCase();
  }
});
